import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalConfig, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SponsorContact, SponsorContactService } from '../../../../services/sponsor-contact.service';

@Component({
  selector: 'app-pod-sponsor-modal',
  templateUrl: './pod-sponsor-modal.component.html',
  styleUrls: ['./pod-sponsor-modal.component.scss']
})
export class PodSponsorModalComponent implements OnInit {
  public modalTitle: string
  public podId: number

  @ViewChild('sponsorModal', { static: false }) private modalContent: TemplateRef<PodSponsorModalComponent>
  private modalRef: NgbModalRef

  sponsorForm: FormGroup = null;
  sponsorModalFailure: string;

  saveButtonClicked: boolean = false;
  loading: boolean = false;

  constructor(
    private modalService: NgbModal,
    private sponsorContactsService: SponsorContactService
  ) {
    this.sponsorForm = new FormGroup({
      sponsorContactId: new FormControl(null, []),
      sponsorName: new FormControl(null, []),
      sponsorEmail: new FormControl(null, [
        Validators.required,
        Validators.email
      ])
    });
}

  ngOnInit() {
  }

  setFormValues(sponsorContactId: number, sponsorName: string, sponsorEmail: string) {
    this.sponsorForm.setValue({
      sponsorContactId: sponsorContactId,
      sponsorName: sponsorName,
      sponsorEmail: sponsorEmail
    })
  }

  open(): Promise<any> {
    this.modalRef = this.modalService.open(this.modalContent);
    return this.modalRef.result;
  }

  async close() {
    console.log(`PodSponsorModal closed`);
    this.modalRef.close(true);
  }

  async dismiss() {
    console.log(`PodSponsorModal dismissed`);
    this.modalRef.dismiss('X');
  }

  onSubmit() {
    this.saveSponsor();
  }

  saveSponsor() {
    if (this.modalHasErrors()) { return; }

    this.saveButtonClicked = true;

    var sponsorContactId = this.sponsorFormId().value;
    var sponsorName = this.sponsorFormName().value;
    var sponsorEmail = this.sponsorFormEmail().value;

    console.log(`Sponsor ID: ${sponsorContactId}`);
    console.log(`Sponsor Name: ${sponsorName}`);
    console.log(`Sponsor Email: ${sponsorEmail}`);

    if (sponsorContactId == null) {
      this.addSponsor(sponsorName, sponsorEmail);
    } else {
      this.editSponsor(sponsorContactId, sponsorName, sponsorEmail);
    }

    this.saveButtonClicked = false;
    this.clearSponsorForm();

    if (!!this.sponsorModalFailure) {
      this.dismiss();
    } else {
      setTimeout(() => {
        this.close();
      }, 1000);
    }
  }

  addSponsor(sponsorName: string, sponsorEmail: string) {
    this.sponsorContactsService.addSponsorContact(this.podId, sponsorName, sponsorEmail);
    //.then(response => {
    //  this.sponsorModalFailure = response.failureMessage;
    //})
    //this.sponsorContactsService.getSponsorContacts(this.podId);
  }

  editSponsor(sponsorContactId: number, sponsorName: string, sponsorEmail: string) {
    this.sponsorContactsService.updateSponsorContact(sponsorContactId, sponsorName, sponsorEmail);
    //.then(response => {
    //  this.sponsorModalFailure = response.failureMessage;
    //});
    //this.sponsorContactsService.getSponsorContacts(this.podId);
  }

  modalHasErrors() {
    return false;
  }

  sponsorFormId() {
    return this.sponsorForm.get('sponsorContactId');
  }

  sponsorFormName() {
    return this.sponsorForm.get('sponsorName');
  }

  sponsorFormEmail() {
    return this.sponsorForm.get('sponsorEmail');
  }

  clearSponsorForm() {
    this.sponsorForm.reset();
  }


}
